import Phaser from "phaser";
import { AUDIO_FEEL_CONFIG } from "../audioFeelConfig";

export class SongEnergySystem {
  private energy: number = AUDIO_FEEL_CONFIG.songEnergyStart;
  private aliveSeconds = 0;

  reset() {
    this.energy = AUDIO_FEEL_CONFIG.songEnergyStart;
    this.aliveSeconds = 0;
  }

  update(dt: number) {
    this.energy = Phaser.Math.Clamp(this.energy - AUDIO_FEEL_CONFIG.songEnergyDrainPerSecond * dt, 0, 1);
    if (this.isAudible) this.aliveSeconds += dt;
  }

  addPickupBoost(multiplier = 1) {
    this.energy = Phaser.Math.Clamp(this.energy + AUDIO_FEEL_CONFIG.songEnergyPickupRestore * multiplier, 0, 1);
  }

  get ratio() {
    return this.energy;
  }

  get isAudible() {
    return this.energy > AUDIO_FEEL_CONFIG.songEnergyAudibleThreshold;
  }

  get isCritical() {
    return this.energy <= AUDIO_FEEL_CONFIG.songEnergyCriticalThreshold;
  }

  get maintainedSeconds() {
    return this.aliveSeconds;
  }
}
